import { makeStyles, tokens } from '@fluentui/react-components';

export const usePageTitleStyles = makeStyles({
    root: {
        fontSize: tokens.fontSizeHero900,
        lineHeight: tokens.lineHeightHero700,
        fontWeight: tokens.fontWeightBold
    }
});
